<template>
  <LoggedLayout>
    <OffersContainer />
  </LoggedLayout>
</template>
<script>
import LoggedLayout from '@/layouts/LoggedLayout.vue'
import OffersContainer from '~/containers/loans/OffersContainer.vue'
export default {
  name: 'Offers',
  components: {
    OffersContainer,
    LoggedLayout,
  },
}
</script>
<style lang="scss"></style>
